export type BillingCurrency = 'USD' | 'AUD';

/** Resolve the trusted country code supplied by the hosting edge. */
export function currencyFromCountryCode(country?: string | null): BillingCurrency {
  return country?.trim().toUpperCase() === 'AU' ? 'AUD' : 'USD';
}
